import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom"; // Import withRouter
import ConfirmApprovedModel from "./ConfirmApprovedModel";
import ConfirmRejectModel from "./ConfirmRejectModel";
const token = localStorage.getItem('authToken');
class EditDonation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textInput: "",
      userName: "",
      title: "",
      category: '', // Initialize as empty
      categoryId: null, // Track the original category ID
      categoryChanged: false, // Track if category has been changed
      areaInput: "",
      categoryData: [],
      currentImageUrl: null,
      submissionStatus: null,
      submeet: false,
      errors: [],
      date: "",
      city: "",
      showModal: false,
      selectedCategoryId: null,
      showModalReject: false,
      selectedCategoryIdReject: null,
      maxSize: 5 * 1024 * 1024, // 5MB in bytes
    };
  }
  

  async componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.id) {
      const { id } = match.params;
      this.setState({ id });
      await this.userData(id);
    } else {
      console.error("No match params found.");
    }
   
  }

  userData = async (id) => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/donation/${id}`,{
        headers: {
          Authorization: `Bearer ${token}`, 
      }
      });
      if (response) {
        console.log(response.data);
        // Format the date to YYYY-MM-DD
    
        this.setState({
          title: response.data.title,
         
          areaInput: response.data.description,
         
        
          currentImageUrl: response.data.image,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };




  handleChange = (e) => {
    const files = Array.from(e.target.files);
    const errors = [];

    files.forEach((file) => {
      if (file.size > this.state.maxSize) {
        errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
      } else {
        this.setState({
          textInput: file,
          currentImageUrl: URL.createObjectURL(file), // Update current image URL to show the new image
        });
      }
    });

    this.setState({ errors });
  };



  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ submeet: true });

    const { textInput, title, areaInput, category, categoryId, categoryChanged, city, date } = this.state;
    const { id } = this.props.match.params;

    try {
      const formData = new FormData();
      formData.append('image', textInput);
      formData.append('title', title);
      formData.append('description', areaInput);

   


      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
         
            Authorization: `Bearer ${token}`, 
      
        },
      };
     

      const response = await axios.put(`https://samaj.aasmo.in/api/admin/donation/${id}`, formData, config);

      if (response.status === 200) {
        this.setState({ submissionStatus: 'success', submeet: false });
        setTimeout(() => {
      this.props.history.push("/donationlist");
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      this.setState({ submissionStatus: 'error' });
    }
  };

  render() {
    const { textInput, showModal, selectedCategoryId,selectedCategoryIdReject, showModalReject,isDateValid,date,title,currentImageUrl,city, userName,category,categoryData, submeet,areaInput, submissionStatus } = this.state;
    const isNameValid = userName.trim().length > 0;
    const isTitleValid = title.trim().length > 0;
    const isCityValid = city?.trim().length > 0;

    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Edit Donation</h2>
          </div>
          <div className="body">
            <form onSubmit={this.handleSubmit}>
            <div className="form-group">
                <label>Title</label>
                <input
                  className={`form-control ${!isTitleValid && submeet && "parsley-error"}`}
                  value={title}
                  name="title"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ title: e.target.value });
                  }}
                />
                {!isTitleValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>
               


    <div className="form-group">
                <label>Image</label>
          
                {currentImageUrl && (
                  <div>
                    <img src={currentImageUrl} alt="Current" style={{ width: '100px', marginBottom: '10px' }} />
                  </div>
                )}
                <input
                  type="file"
                  className={`form-control`}
                  name="textInput"
                  // required=""
                  onChange={this.handleChange}
                />
                {/* {!textInput && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null} */}
              </div>

                 <div className="form-group">
                <label>Description</label>
                <textarea
                  className={`form-control ${areaInput === "" && submeet && "parsley-error"
                    }`}
                  value={areaInput}
                  cols="30"
                  name="textarea"
                  required=""
                  rows="5"
                  onChange={(e) => {
                    this.setState({ areaInput: e.target.value });
                  }}
                ></textarea>
                {areaInput === "" && submeet ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>
        
              {submissionStatus === 'success' && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}

              <button className="btn btn-primary" type="submit">
                Submit
              </button>
            </form>
          </div>
        </div>
        <ConfirmApprovedModel
          show={showModal}
          handleClose={() => this.setState({ showModal: false })}
          handleConfirm={() => this.handleUpdate(selectedCategoryId)}
        />
         <ConfirmRejectModel
          show={showModalReject}
          handleClose={() => this.setState({ showModalReject: false })}
          handleConfirm={() => this.handleUpdateReject(selectedCategoryId)}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, { notifyGeneralInfo })(withRouter(EditDonation)); // Wrap with withRouter
